import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Context as PosContext } from '@squareup/sq-addons-web-sdk'

export type State = {
  context: PosContext | null
}

const slice = createSlice({
  name: 'pos',
  initialState: {
    context: null,
  } as State,
  reducers: {
    setContext: (state, action: PayloadAction<PosContext>) => {
      state.context = action.payload
    },
  },
})

export const { setContext } = slice.actions

export default slice.reducer
